import { create } from "zustand";

const initialStepsState = {
  currentStep: 1,
  nextStepDisabled: false,
  maxSteps: 3,
};

export type StepsState = typeof initialStepsState;

export const useStepsStore = create<StepsState>(() => ({
  ...initialStepsState,
}));
